import React from 'react'
import {components} from 'react-select'
import {Box, Flex, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CheckIcon} from '../../icons'
import {remCalc} from '../../../theme/_utils'

const Option = (props) => {
    return (
        <components.Option {...props}>
            <Flex justifyContent="space-between" alignItems="center" w="100%">
                <Box flex="1" minW={0}>
                    {props.children || <Text>{props.label}</Text>}
                </Box>
                {props.isSelected && <CheckIcon width={remCalc(10)} height={remCalc(10)} />}
            </Flex>
        </components.Option>
    )
}

Option.propTypes = {
    children: PropTypes.node,
    data: PropTypes.any,
    isSelected: PropTypes.bool,
    label: PropTypes.string,
}

export default Option
